<template>
  <v-card v-if="showSubmittedSuccessfully">
    <v-card-text class="text-center">
      <div class="text-center mt-5">
        <v-avatar color="#FDE1D6" size="70">
          <v-icon dark color="primary" large> mdi-check </v-icon>
        </v-avatar>
      </div>

      <v-card-title class="justify-center text-center"
        >Your information has <br />
        been submitted</v-card-title
      >
      <v-row>
        <v-col cols="8" offset="2">
          <p>
            You can come back to this link at anytime to update your details
            before the event starts on
            {{ new Date(event.startDateTime).toDateString() }}.
          </p>
        </v-col>
        <!-- <v-col cols="8" offset="2">
          <v-btn
            class="primary text-right"
            depressed
            large
            width="200"
            @click="handleClick"
            >OK</v-btn
          >
        </v-col> -->
      </v-row>
    </v-card-text>
  </v-card>
  <v-card class="px-0 mx-0" v-else>
    <v-card-title class="justify-space-between align-start">
      <template v-if="tab != 3">
        <template v-if="isSponsorsMode">
          <div v-if="tab == 0">
            <template v-if="currentSponsor.isReviewed"
              >Update your details</template
            >
            <template v-else>Fill in your business details</template>
          </div>
          <div v-else-if="tab == 1">
            <div v-if="tab != 0">
              <v-btn fab text small @click="handleBack"
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
            </div>
            Contact details
          </div>
        </template>
        <template v-else>
          <div v-if="isEditingSponsor">Edit {{ promoterType }}</div>
          <div v-else>
            <div v-if="tab != 0">
              <v-btn fab text small @click="handleBack"
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
            </div>
            <div v-if="tab==0">Add a {{ promoterType }}</div>
            <div v-else-if="tab==1">Add their Business Contacts and Socials (optional)</div>
            <div v-else-if="tab==2">Grant Access</div>
          </div>
        </template>
      </template>
      <div class="pl-5" v-else>
        <div v-if="tab != 0">
          <v-btn fab text small @click="handleBack"
            ><v-icon>mdi-chevron-left</v-icon></v-btn
          >
        </div>
        Edit image
      </div>
      <div class="d-block"></div>

      <v-btn fab text small @click="$emit('close')" v-if="!isSponsorsMode"
        ><v-icon class="text-right text--secondary">close</v-icon></v-btn
      >
    </v-card-title>
    <v-card-subtitle>
      <template v-if="isSponsorsMode">
        <div v-if="tab == 0">
          <template v-if="currentSponsor.isReviewed"
            >Your details will be displayed on {{ event.name }} event link for
            all attendees to see. You can make changes at any time before
            {{ new Date(event.startDateTime).toDateString() }}.
            <span
              class="text-decoration-underline cursor-pointer"
              @click="show = true"
            >
              See example.
            </span></template
          >
          <template v-else>
            Your details will be displayed on {{ event.name }} event link for
            all attendees to see.
            <span
              class="text-decoration-underline cursor-pointer"
              @click="show = true"
            >
              See example </span
            >.</template
          >
        </div>
        <div v-else-if="tab == 1">
          Who should {{ event.hostName }} reach out to if there are any issues
          with the information or image provided?
        </div>
      </template>
      <template v-else>
        <template v-if="tab == 0"></template>
        <template v-if="tab == 2">
          Provide access to your event {{ promoterType.toLowerCase() }} so they can complete the set up
          of their Pappyon account, invite their representatives to join your event and update details.
        </template>
      </template>
    </v-card-subtitle>

    <v-card-text>
      <v-alert
        text
        prominent
        dense
        color="primary"
        icon="priority_high"
        v-if="new Date() > event.startDateTime && isSponsorsMode"
      >
        <v-row align="center">
          <v-col class="grow"
            >{{ event.name }} has started already. Please contact your event
            organizer for any updates if required.</v-col
          >
        </v-row>
      </v-alert>
      <v-form
        v-model="isAddEditSponsorFormValid"
        :disabled="new Date() > event.startDateTime && isSponsorsMode"
      >
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row v-if="isSponsorsMode">
              <v-col cols="12" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="Business name"
                  label="Business name"
                  v-model="currentSponsor.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="website URL"
                  label="website URL"
                  v-model="currentSponsor.website"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <div
                  class="sponsors-logo-dropzone-wrapper"
                  v-if="currentSponsor.logoURL == ''"
                >
                  <div class="sponsors-logo-dropzone-container">
                    <v-btn
                      v-if="initialImageURL != ''"
                      class="mb-1"
                      small
                      text
                      style="color: #616161"
                      @click="handleResetLogo"
                      ><v-icon small class="mr-2">mdi-restore</v-icon> Reset
                    </v-btn>
                    <vue-dropzone
                      ref="sponsorsLogoDropzone"
                      id="sponsorsLogoDropzone"
                      :options="dropzoneOptions"
                      @vdropzone-file-added="fileAdded"
                      :useCustomSlot="true"
                    >
                      <div
                        class="d-flex align-center justify-center flex-column"
                        style="height: 100%"
                      >
                        <div>
                          <v-icon>mdi-image-outline</v-icon>
                        </div>
                        <div>Upload sponsor’s logo</div>
                      </div>
                    </vue-dropzone>
                  </div>
                </div>
                <div
                  v-else
                  class="sponsors-logo-dropzone-wrapper d-flex align-center"
                >
                  <div class="d-flex">
                    <v-card class="mr-2 pa-0 outlined-border">
                      <v-img
                        :aspect-ratio="378 / 250"
                        height="187.5"
                        width="283.5"
                        :src="currentSponsor.logoURL"
                      ></v-img>
                    </v-card>
                    <div class="d-flex flex-column">
                      <AvatarButton
                        icon="mdi-pencil"
                        tooltipText="Edit logo"
                        className="d-inline-block mb-2"
                        @click="handleDeleteLogo"
                      />
                      <AvatarButton
                        icon="mdi-trash-can"
                        tooltipText="Delete logo"
                        className="d-inline-block mb-2"
                        @click="handleDeleteLogo"
                      />
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row v-else class="mx-0 px-0 dense pb-0">
              <!-- <v-col cols="12" class="pb-0 px-0">
                <v-autocomplete
                  outlined
                  dense
                  :items="promoterTypeItems"
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="Type of Event Partner"
                  v-model="currentSponsor.promoterType"
                ></v-autocomplete>
              </v-col> -->
              <v-col cols="12" class="pb-0 px-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  :placeholder="`${promoterType} name (Business name)`"
                  v-model="currentSponsor.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="px-0 py-0">
                <v-text-field
                  outlined
                  dense
                  validate-on-blur
                  :rules="requiredRules"
                  :placeholder="`Link to ${currentSponsor.promoterType.toLowerCase()}’s website URL`"
                  v-model="currentSponsor.website"
                  :hint="`e.g. ${urlPrefixes.urlPrefix}www.pappyon.com`"
                >
                  <template v-slot:prepend-inner>
                    <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.urlPrefix }}</div>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" class="py-0 px-0">
                <v-text-field
                    outlined
                    dense
                    :rules="requiredRules"
                    validate-on-blur
                    :placeholder="`${promoterType} Type`"
                    v-model="currentSponsor.sponsorType"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="px-0 py-0">
                <v-textarea outlined dense validate-on-blur :rules="requiredRules" :placeholder="`Bio`"
                              v-model="currentSponsor.bio"/>
              </v-col>
              <v-col cols="12" class="mx-0 px-0">
                <div
                  class="sponsors-logo-dropzone-wrapper"
                  v-if="currentSponsor.logoURL == ''"
                >
                  <div class="sponsors-logo-dropzone-container">
                    <vue-dropzone
                      ref="sponsorsLogoDropzone"
                      id="sponsorsLogoDropzone"
                      :options="dropzoneOptions"
                      @vdropzone-file-added="fileAdded"
                      :useCustomSlot="true"
                    >
                      <div
                        class="d-flex align-center justify-center flex-column"
                        style="height: 100%"
                      >
                        <div>
                          <v-icon>mdi-image-outline</v-icon>
                        </div>
                        <div>
                          Upload
                          {{ promoterType.toLowerCase() }}’s logo
                        </div>
                      </div>
                    </vue-dropzone>
                  </div>
                </div>
                <div
                  v-else
                  class="sponsors-logo-dropzone-wrapper d-flex align-center"
                >
                  <div class="d-flex">
                    <v-card class="mr-2 pa-0 outlined-border">
                      <v-img
                        :aspect-ratio="378 / 250"
                        height="187.5"
                        width="283.5"
                        :src="currentSponsor.logoURL"
                      ></v-img>
                    </v-card>
                    <div>
                      <AvatarButton
                        icon="mdi-trash-can"
                        tooltipText="Delete logo"
                        className="d-inline-block mr-2"
                        @click="handleDeleteLogo"
                      />
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-card-subtitle class="py-0 ma-0">
              <span class="font-weight-bold">
                <template>
                  Business Contacts
                </template>
              </span>
            </v-card-subtitle>

            <v-col cols="12" class="pb-0">
              <ContactNumber backgroundColor="white" v-model="currentSponsor.generalPhone"
                             :autofocus="false" label="General Phone Number" value="General Phone Number" :is-required="false" />
              <v-text-field outlined dense :rules="requiredRules" validate-on-blur placeholder="General Email"
                            label="General Email" v-model="currentSponsor.generalEmail"></v-text-field>
            </v-col>
            <v-card-subtitle class="pt-0 pb-1">
              <span class="font-weight-bold">

                <template>
                  Business Socials
                </template>
              </span>
            </v-card-subtitle>
            <v-col cols="12" class="pb-0">
              <v-text-field outlined dense :rules="requiredRules" validate-on-blur placeholder="yourhandle"
                            label="Facebook" v-model="currentSponsor.facebook"
                            :hint="`e.g. ${urlPrefixes.facebookUrlPrefix}pappyon`">
                <template v-slot:prepend-inner>
                  <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.facebookUrlPrefix }}</div>
                </template>
              </v-text-field>
              <v-text-field outlined dense :rules="requiredRules" validate-on-blur label="Instagram"
                            v-model="currentSponsor.instagram" placeholder="yourhandle"
                            :hint="`e.g. ${urlPrefixes.instagramUrlPrefix}pappyon`">
                <template v-slot:prepend-inner>
                  <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.instagramUrlPrefix }}</div>
                </template>
              </v-text-field>
              <v-text-field outlined dense :rules="requiredRules" validate-on-blur label="LinkedIn"
                            v-model="currentSponsor.linkedin" placeholder="yourhandle"
                            :hint="`e.g. ${urlPrefixes.linkedinUrlPrefix}pappyon`">
                <template v-slot:prepend-inner>
                  <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.linkedinUrlPrefix }}</div>
                </template>
              </v-text-field>
              <v-text-field outlined dense :rules="requiredRules" validate-on-blur label="Twitter"
                            v-model="currentSponsor.twitter" placeholder="yourhandle"
                            :hint="`e.g. ${urlPrefixes.twitterUrlPrefix}pappyon`">
                <template v-slot:prepend-inner>
                  <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.twitterUrlPrefix }}</div>
                </template>
              </v-text-field>
              <v-text-field outlined dense :rules="requiredRules" validate-on-blur label="YouTube"
                            v-model="currentSponsor.youtube" placeholder="yourhandle">
                <template v-slot:prepend-inner>
                  <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.youtubeurlPrefix }}</div>
                </template>
              </v-text-field>
              <v-text-field outlined dense :rules="requiredRules" validate-on-blur label="Podcast"
                            v-model="currentSponsor.podcast">
                <template v-slot:prepend-inner>
                  <div class="ml-1 mr-n1 mt-1">{{ urlPrefixes.urlPrefix }}</div>
                </template>
              </v-text-field>
            </v-col>

          </v-tab-item>
          <v-tab-item>
            <v-row v-if="isSponsorsMode">
              <v-col cols="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="First Name"
                  label="First Name"
                  v-model="currentSponsor.firstName"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="Last Name"
                  label="Last Name"
                  v-model="currentSponsor.lastName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="Email"
                  label="Email"
                  v-model="currentSponsor.email"
                ></v-text-field> </v-col
            ></v-row>
            <v-row v-else>
              <v-col cols="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="First Name"
                  v-model="currentSponsor.firstName"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="Last Name"
                  v-model="currentSponsor.lastName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  :rules="requiredRules"
                  validate-on-blur
                  placeholder="Email"
                  v-model="currentSponsor.email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" class="">
                <ImageCropper
                  :selectedImage="selectedImage"
                  @uploaded="handleUploaded"
                  previewType="rectangle"
                  :key="refreshCropper"
                />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <div>
          <v-col offset="2">
            <v-row>
              <v-col cols="5">
                <v-btn v-if="tab == 2" class="primary text-right" depressed large block :disabled="isBtnDisabled"
                       width="150"
                       @click="handleSaveSponsor(true)">Done and add another
                </v-btn>

              </v-col>
              <v-col cols="5">
                <v-btn v-if="tab != 3" class="primary text-right" depressed large block :disabled="isBtnDisabled"
                       width="150"
                       @click="handleSaveSponsor(false)">{{ btnText }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </v-form>
      <SponsorsExampleDialog :show="show" @close="show = false" />
    </v-card-text>
  </v-card>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ImageCropper from "@/components/ImageCropper";
import AvatarButton from "@/components/AvatarButton";
import { mapActions, mapGetters } from "vuex";
import SponsorsExampleDialog from "@/components/MultiConnect/SponsorsExampleDialog";
import Attendee from "@/models/Attendee";
let uuid = require("uuid");
import Sponsor from "@/models/Sponsor";
import ContactNumber from "@/components/inputs/ContactNumber.vue";

export default {
  props: {
    isEditingSponsor: { type: Boolean, default: false },
    isFirstSponsor: {type: Boolean, default: false},
    sponsor: {
      type: Sponsor,
      default: function () {
        return null;
      },
    },
    isEditingMCEvent: { type: Boolean, default: false },
    isSponsorsMode: { type: Boolean, default: false },
    event: {
      type: Object,
      default: function () {
        return {};
      },
    },
    eventCategory: { type: String, default: "multiConnect" },
  },

  created() {
    const eventId = this.$route.params.eventId;
    const subEventId = this.$route.params.subEventId;


    this.currentSponsor = this.sponsor;

    //Set the initial image if sponsor has a logoURL uploaded already
    if (this.currentSponsor.logoURL != "")
      this.initialImageURL = this.currentSponsor.logoURL;

    if (this.isFirstSponsor) {
      this.promoterType = "Partner/Sponsor";
    } else {
      this.promoterType = this.currentSponsor.promoterType;
    }
    this.currentSponsor.eventId = subEventId || eventId;
  },

  components: {
    ContactNumber,
    vueDropzone: vue2Dropzone,
    ImageCropper,
    AvatarButton,
    SponsorsExampleDialog,
  },
  computed: {
    ...mapGetters(["currentEvent", "userProfile", "currentSubEvent", "urlPrefixes"]),
    btnText() {
      if(this.tab == 2) {
        return "Done";
      }
      // if (this.isSponsorsMode) {
      //   return this.tab == 0 ? "Next" : "Submit";
      // } else {
      //   return this.tab == 0
      //     ? "Next"
      //     : "Add " + this.currentSponsor.promoterType.toLowerCase();
      // }
      return "Next";
    },
    isBtnDisabled() {
      // if (this.isSponsorsMode) {
      if (this.tab == 0) {
        //Validate the fields in te first tab
        if (
          this.currentSponsor.name != "" &&
          this.currentSponsor.website != "" &&
          this.currentSponsor.logoURL != "" &&
            this.currentSponsor.bio != ""
        )
          return false;
        else return true;
      } else if (this.tab == 1) {

        return false
      } else if (this.tab == 2) {
        //Validate the fields in the second tab
        if (
          this.currentSponsor.firstName != "" &&
          this.currentSponsor.lastName != "" &&
          this.currentSponsor.email != ""
        )
          return false;
        else return true;
      }
      // } else {
      //   return !this.isAddEditSponsorFormValid;
      // }
    },
  },
  data() {
    return {
      tab: 0,
      refreshCropper: 0,
      isAddEditSponsorFormValid: false,
      requiredRules: [(v) => v=="" || !!v || "This field is required"],
      dropzoneOptions: {
        autoProcessQueue: false,
        url: "http://localhost",
        previewsContainer: false,
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      selectedImage: "",
      show: false,
      showSubmittedSuccessfully: false,
      initialImageURL: "",
      promoterTypeItems: ["Sponsor", "Partner"],
      currentSponsor: {},
      promoterType: "Partner"
    };
  },
  watch: {
    "currentSponsor.facebook": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.facebookUrlPrefix)) {
        this.currentSponsor.facebook = this.currentSponsor.facebook.replace(
            this.urlPrefixes.facebookUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.instagram": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.instagramUrlPrefix)) {
        this.currentSponsor.instagram = this.currentSponsor.instagram.replace(
            this.urlPrefixes.instagramUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.twitter": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.twitterUrlPrefix)) {
        this.currentSponsor.twitter = this.currentSponsor.twitter.replace(
            this.urlPrefixes.twitterUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.linkedin": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.linkedinUrlPrefix)) {
        this.currentSponsor.linkedin = this.currentSponsor.linkedin.replace(
            this.urlPrefixes.linkedinUrlPrefix,
            ""
        );
      }
    },
    "currentSponsor.website": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.currentSponsor.website = this.currentSponsor.website.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
    "currentSponsor.podcast": function (newVal, oldVal) {
      if (newVal.startsWith(this.urlPrefixes.urlPrefix)) {
        this.currentSponsor.podcast = this.currentSponsor.podcast.replace(this.urlPrefixes.urlPrefix, "");
      }
    },
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    handleBack() {
      //START: COMMENTED FOR SOUTH START
      // if (this.isSponsorsMode) {
      //   if (this.tab == 2 || this.tab == 1) this.tab = 0;
      // } else {
      //   if (this.tab == 2) this.tab = 1;
      //   else this.tab = 0;
      // }
      //END: COMMENTED FOR SOUTH START

      this.tab = 0;

      this.refreshCropper = 0;
    },
    async fileAdded(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async (event) => {
        //event.target.result - is dataURL datas
        let base64String = event.target.result;
        this.selectedImage = base64String;
        this.tab = 3;
        this.refreshCropper = 1;
      };
    },
    handleDeleteLogo() {
      // if(this.isSponsorsMode){

      // }else{

      // }
      this.currentSponsor.logoURL = "";
      this.refreshCropper = 0;
      // this.tab = 0;
    },
    handleUploaded(downloadURL, logoFrame) {
      this.currentSponsor.logoURL = downloadURL;
      this.refreshCropper = 0;
      if (this.isSponsorsMode) {
        this.tab = 0;
      } else {
        this.tab = 0;
      }
    },
    async handleSaveSponsor(isAddAnother) {
      if (this.tab != 2) {
        this.tab++;
        return;
      };
      if (this.isSponsorsMode) {
        //Check if this is the first time sponsor is opening this link
        let isReviewingForFirstTime = !this.currentSponsor.isReviewed;

        //Mark the page as reviewed by sponsor
        this.currentSponsor.isReviewed = true;

        let sponsorRef = await this.currentSponsor.save();


        //Find the old sponsor from event and replace it with new sponsor data
        let index = this.event.sponsors.findIndex(
          (sponsor) => sponsor.uid == this.currentSponsor.uid
        );
        this.currentSponsor.sponsorDocRef = sponsorRef

        this.event.sponsors.splice(index, 1, this.currentSponsor);

        //Save the event
        await this.event.save();

        //Send an email to sponsor if they reviewed the info for the first time
        if (isReviewingForFirstTime) {
          this.currentSponsor.sendReviewCompletedEmail(
            this.event.id,
            this.event.name,
            this.event.hostName,
            "multiConnect"
          );

          //Show success card
          this.showSubmittedSuccessfully = true;
        } else {
          this.showSnackbar({ show: true, text: "Saved successfully!" });
        }
      } else {
        //Set isReviewed to true when organiser creates a sponsor
        this.currentSponsor.isReviewed = true;

        let isSponsorAdded = false;

        let sponsorRef = await this.currentSponsor.save();
        this.currentSponsor.sponsorDocRef = sponsorRef

        //Create a new sponsor
        if (!this.isEditingSponsor) {
          this.currentEvent.sponsors.push(this.currentSponsor);
          isSponsorAdded = true;
        } else {
          //Update the sponsor in the current event array
          let index = this.currentEvent.sponsors.findIndex(
            (sponsor) => sponsor.uid == this.currentSponsor.uid
          );
          this.currentEvent.sponsors.splice(index, 1, this.currentSponsor);
        }
        await this.currentEvent.save();

         this.showSnackbar({ show: true, text: "Updated successfully!" });

        //Send an email to sponsor if organiser added them while editing the Mc event
        //START: COMMENTED FOR SOUTHSTART
        // if (this.isEditingMCEvent) {
        //   this.currentSponsor.sendInvitationEmail(
        //     this.currentEvent.id,
        //     this.currentEvent.name,
        //     this.currentEvent.hostName,
        //     "multiConnect"
        //   );

        //   await this.addAttendee(this.currentSponsor);

        //   this.showSnackbar({
        //     show: true,
        //     text: "Sponsor invited successfully!",
        //   });
        // }
        //END: COMMENTED FOR SOUTHSTART
        if(!isAddAnother) {
        if (isSponsorAdded)
          this.$emit("sponsor-added", this.currentSponsor.promoterType);
        else this.$emit("close");
        } else {
          this.currentSponsor = new Sponsor({uid: uuid.v4(), eventId: this.currentEvent.id});
          this.tab = 0;
        }
      }
    },
    handleClick() {
      this.tab = 0;
      this.showSubmittedSuccessfully = false;
    },
    handleResetLogo() {
      this.currentSponsor.logoURL = this.initialImageURL;
    },
    async addAttendee(sponsor) {
      if (
        !this.currentEvent.invitees.some(
          (invitee) => invitee.email == sponsor.email
        )
      ) {
        let invitee = new Attendee({
          email: sponsor.email,
          attendeeId: uuid.v4(),
          invitedAt: new Date(),
        });
        this.currentEvent.invitees.unshift(invitee);

        //Save
        this.currentEvent.save();

       

        invitee.sendInvitation(
          this.currentEvent.linkPrivacy,
          this.currentEvent.dynamicLink,
          this.currentEvent.name,
          this.userProfile.firstName,
          this.userProfile.lastName,
          this.currentEvent.hostName
        );
      }
    },
  },
};
</script>

<style scoped>
.sponsors-logo-dropzone-container {
  width: 80%;
  min-height: 180px;
  padding: 16px;
}

.sponsors-logo-dropzone-wrapper {
  background-color: #f6f7fc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 280px;
  /* margin-left: -4px;
  margin-right: -4px; */
}

#sponsorsLogoDropzone {
  height: 200px;
  background-color: white !important;
  border: 3px dashed #5160774d !important;
  border-radius: 8px;
}

/*CSS for inner elements of the sponsor sheet */
.inner-rounded-r-lg {
  border-top-right-radius: 7px !important;
  border-bottom-right-radius: 7px !important;
}

.inner-rounded-l-lg {
  border-top-left-radius: 7px !important;
  border-bottom-left-radius: 7px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.restore-btn {
  color: #5160774d;
}
</style>